// Library imports.
import axios, { AxiosResponse } from "axios";
import { baseWorker, IFiscalYear } from "../baseWorker";
// App imports.
import { config } from "../config";
import axiosInstance from '../axiosInstance';

export interface IFieldToUpdate {
  fuel: string
  , field: string
  , value: any
}
export interface INumHouseholdsByFuel {
  granteeId: number
  , fiscalYear: number
  , numberOfAssistedHouseholdsAll: number
  , numberOfAssistedHouseholdsElectric: number
  , numberOfAssistedHouseholdsNaturalGas: number
  , numberOfAssistedHouseholdsFuelOil: number
  , numberOfAssistedHouseholdsPropane: number
  , numberOfAssistedHouseholdsOther: number
  , householdsBillingDataElectric: number
  , householdsBillingDataNaturalGas: number
  , householdsBillingDataFuelOil: number
  , householdsBillingDataPropane: number
}
export interface IAverageExpenditureByFuel {
  granteeId: number
  , fiscalYear: number
  , validPMDataReported: boolean
  , sedsElectricNonHeatExpenditureNaturalGas: number
  , sedsElectricNonHeatCodeNaturalGas: string
  , sedsElectricNonHeatExpenditureFuelOil: number
  , sedsElectricNonHeatCodeFuelOil: string
  , sedsElectricNonHeatExpenditurePropane: number
  , sedsElectricNonHeatCodePropane: string
  , computedAverageExpenditureNaturalGas: number
  , computedAverageExpenditureFuelOil: number
  , computedAverageExpenditurePropane: number
  , numberOfAssistedHouseholdsElectric: number
  , numberOfAssistedHouseholdsNaturalGas: number
  , numberOfAssistedHouseholdsFuelOil: number
  , numberOfAssistedHouseholdsPropane: number
  , householdsBillingDataElectric: number
  , householdsBillingDataNaturalGas: number
  , householdsBillingDataFuelOil: number
  , householdsBillingDataPropane: number
}

export class Worker extends baseWorker {

  public async getSedsData(inGranteeId: number, inFiscalYear: number): Promise<IAverageExpenditureByFuel> {

    const formData = new FormData();
    const DATA_OK: string = 'VLOK';
    const INVALID_PM: string = 'INVP';

    let averageExpenditure: IAverageExpenditureByFuel = {
      fiscalYear: inFiscalYear,
      granteeId: inGranteeId,
      validPMDataReported: true,
      sedsElectricNonHeatExpenditureNaturalGas: null,
      sedsElectricNonHeatCodeNaturalGas: '',
      sedsElectricNonHeatExpenditureFuelOil: null,
      sedsElectricNonHeatCodeFuelOil: '',
      sedsElectricNonHeatExpenditurePropane: null,
      sedsElectricNonHeatCodePropane: '',
      computedAverageExpenditureNaturalGas: null,
      computedAverageExpenditureFuelOil: null,
      computedAverageExpenditurePropane: null,
      numberOfAssistedHouseholdsElectric: null,
      numberOfAssistedHouseholdsNaturalGas: null,
      numberOfAssistedHouseholdsFuelOil: null,
      numberOfAssistedHouseholdsPropane: null,
      householdsBillingDataElectric: null,
      householdsBillingDataNaturalGas: null,
      householdsBillingDataFuelOil: null,
      householdsBillingDataPropane: null,
    };

    try {

      formData.append('granteeId', String(inGranteeId));
      formData.append('fiscalYear', String(inFiscalYear));

      
      const response: AxiosResponse =
        //using the apiBaseURL property defined in config.ts which we import above
        await axiosInstance.get(`${config.apiBaseURL}/datareliability/sedsdata/${inFiscalYear}/grantee/${inGranteeId}`);               

      //getSeds data
      if (response.data.length > 1) {
        response.data[0].map(datarow => {
          switch (datarow["FUEL_CD"]) {
            case "NG":
              averageExpenditure.sedsElectricNonHeatExpenditureNaturalGas = this.nullOrNumberToNumber(datarow["ELECTRIC_NON_HEAT"]);
              averageExpenditure.sedsElectricNonHeatCodeNaturalGas = datarow["ELECTRIC_NON_HEAT_CODE"];
              break;
            case "FO":
              averageExpenditure.sedsElectricNonHeatExpenditureFuelOil = this.nullOrNumberToNumber(datarow["ELECTRIC_NON_HEAT"]);
              averageExpenditure.sedsElectricNonHeatCodeFuelOil = datarow["ELECTRIC_NON_HEAT_CODE"];
              break;
            case "PR":
              averageExpenditure.sedsElectricNonHeatExpenditurePropane = this.nullOrNumberToNumber(datarow["ELECTRIC_NON_HEAT"]);
              averageExpenditure.sedsElectricNonHeatCodePropane = datarow["ELECTRIC_NON_HEAT_CODE"];
              break;
          }

          //set validPMDataReported to false if any fuel has "Invalid PM" status
          if (datarow["ELECTRIC_NON_HEAT_CODE"] == INVALID_PM) {
            averageExpenditure.validPMDataReported = false;
          }

        });
        if (response.data[1].length > 0) {
          averageExpenditure.computedAverageExpenditureNaturalGas = this.nullOrNumberToNumber(response.data[1][0]["NATURAL_GAS_ELECTRIC_BILL"]);
          averageExpenditure.computedAverageExpenditureFuelOil = this.nullOrNumberToNumber(response.data[1][0]["FUEL_OIL_ELECTRIC_BILL"]);
          averageExpenditure.computedAverageExpenditurePropane = this.nullOrNumberToNumber(response.data[1][0]["PROPANE_ELECTRIC_BILL"]);
          averageExpenditure.numberOfAssistedHouseholdsElectric = this.nullOrNumberToNumber(response.data[1][0]["NUM_HOUSEHOLDS_ELECTRIC_MAIN_HEAT"]);
          averageExpenditure.numberOfAssistedHouseholdsNaturalGas = this.nullOrNumberToNumber(response.data[1][0]["NUM_HOUSEHOLDS_NATURAL_GAS_MAIN_HEAT"]);
          averageExpenditure.numberOfAssistedHouseholdsFuelOil = this.nullOrNumberToNumber(response.data[1][0]["NUM_HOUSEHOLDS_FUEL_OIL_MAIN_HEAT"]);
          averageExpenditure.numberOfAssistedHouseholdsPropane = this.nullOrNumberToNumber(response.data[1][0]["NUM_HOUSEHOLDS_PROPANE_MAIN_HEAT"]);

          averageExpenditure.householdsBillingDataElectric = this.nullOrNumberToNumber(response.data[1][0]["HOUSEHOLDS_WITH_DATA_ELECTRIC"]);
          averageExpenditure.householdsBillingDataNaturalGas = this.nullOrNumberToNumber(response.data[1][0]["HOUSEHOLDS_WITH_DATA_NATURAL_GAS"]);
          averageExpenditure.householdsBillingDataFuelOil = this.nullOrNumberToNumber(response.data[1][0]["HOUSEHOLDS_WITH_DATA_FUELOIL"]);
          averageExpenditure.householdsBillingDataPropane = this.nullOrNumberToNumber(response.data[1][0]["HOUSEHOLDS_WITH_DATA_PROPANE"]);


          //if a row was returend (i.e. this is a valid reporting year) but values are null, no valid pm data
          averageExpenditure.validPMDataReported = true;
          console.log('averageExpenditure', averageExpenditure);
          if (averageExpenditure.numberOfAssistedHouseholdsNaturalGas === null
            && averageExpenditure.numberOfAssistedHouseholdsFuelOil === null
            && averageExpenditure.numberOfAssistedHouseholdsPropane === null) {

            averageExpenditure.validPMDataReported = false;
            console.log('invalid');
          }

        }
      }

    }
    catch (error) {
      return this.handleError(error);
    }
    return averageExpenditure;
  }
  public async getSedsCodeValues(): Promise<string[]> {
    let sedsValueCodesAssociativeArray: string[] = [];

    try {
      
      const response: AxiosResponse =
        //using the apiBaseURL property defined in config.ts which we import above
        await axiosInstance.get(`${config.apiBaseURL}/electricbaseload/sedscodevalues`);
      response.data.map(r => {
        sedsValueCodesAssociativeArray[r["SDCV_CD"]] = r["SDCV_NOTE_EB"];
      });
    }
    catch (error) {
      return this.handleError(error);
    }
    return sedsValueCodesAssociativeArray;
  }
  public async getNumhouseHolds(inGranteeId: number, inFiscalYear: number): Promise<INumHouseholdsByFuel> {

    let numHouseholds: INumHouseholdsByFuel = {
      fiscalYear: inFiscalYear,
      granteeId: inGranteeId,
      numberOfAssistedHouseholdsAll: null,
      numberOfAssistedHouseholdsElectric: null,
      numberOfAssistedHouseholdsNaturalGas: null,
      numberOfAssistedHouseholdsFuelOil: null,
      numberOfAssistedHouseholdsPropane: null,
      numberOfAssistedHouseholdsOther: null,
      householdsBillingDataElectric: null,
      householdsBillingDataNaturalGas: null,
      householdsBillingDataFuelOil: null,
      householdsBillingDataPropane: null,
    };


    try {
      
      const response: AxiosResponse =
        //using the apiBaseURL property defined in config.ts which we import above
        await axiosInstance.get(`${config.apiBaseURL}/datareliability/numhouseholds/${inFiscalYear}/grantee/${inGranteeId}`);

      if (response.data.length > 0) {
        numHouseholds.numberOfAssistedHouseholdsAll = this.nullOrNumberToNumber(response.data[0]["NUM_HOUSEHOLDS_ALL"]);
        numHouseholds.numberOfAssistedHouseholdsElectric = this.nullOrNumberToNumber(response.data[0]["NUM_HOUSEHOLDS_ELECTRIC"]);
        numHouseholds.numberOfAssistedHouseholdsNaturalGas = this.nullOrNumberToNumber(response.data[0]["NUM_HOUSEHOLDS_NATURAL_GAS"]);
        numHouseholds.numberOfAssistedHouseholdsFuelOil = this.nullOrNumberToNumber(response.data[0]["NUM_HOUSEHOLDS_FUELOIL"]);
        numHouseholds.numberOfAssistedHouseholdsPropane = this.nullOrNumberToNumber(response.data[0]["NUM_HOUSEHOLDS_PROPANE"]);
        numHouseholds.numberOfAssistedHouseholdsOther = this.nullOrNumberToNumber(response.data[0]["NUM_HOUSEHOLDS_OTHER"]);

        numHouseholds.householdsBillingDataElectric = this.nullOrNumberToNumber(response.data[0]["HOUSEHOLDS_WITH_DATA_ELECTRIC"]);
        numHouseholds.householdsBillingDataNaturalGas = this.nullOrNumberToNumber(response.data[0]["HOUSEHOLDS_WITH_DATA_NATURAL_GAS"]);
        numHouseholds.householdsBillingDataFuelOil = this.nullOrNumberToNumber(response.data[0]["HOUSEHOLDS_WITH_DATA_FUELOIL"]);
        numHouseholds.householdsBillingDataPropane = this.nullOrNumberToNumber(response.data[0]["HOUSEHOLDS_WITH_DATA_PROPANE"]);
      }
    }
    catch (error) {
      return this.handleError(error);
    }
    return numHouseholds;
  }

}
